<template>
    <tab-section title="Budget & Pricing" :class="{'lam-lower-contrast': !!wizardShown}">
        <div class="uk-grid uk-grid-small" data-uk-grid-margin>
            <div class="uk-width-1-1">
                <div class="uk-form-controls-text uk-text-bold">Project Construction Budget</div>
                <form-input
                    id="construction_budget"
                    type="float"
                    v-model="record.construction_budget"
                    name="construction_budget"
                    glyph="dollar"
                    :error="has_error('construction_budget')"
                    :required="false"
                    :editable="editable"
                    width="1-1"
                    @input="save_field"
                    class="uk-width-1-1"
                />
            </div>
            <!--
            <div class="uk-width-1-2">
                <div class="uk-form-controls-text uk-text-bold">Electrical</div>
                <form-input
                    id="electrical_budget"
                    type="float"
                    v-model="record.electrical_budget"
                    name="electrical_budget"
                    glyph="dollar"
                    :error="has_error('electrical_budget')"
                    :required="false"
                    :editable="editable"
                    width="1-1"
                    @input="save_field"
                    class="uk-width-1-1"
                />
            </div>
            //-->

            <div class="uk-width-1-2">
                <div class="uk-form-controls-text uk-text-bold">Lighting Budget</div>
                <form-input
                    id="lighting_budget"
                    type="float"
                    v-model="record.lighting_budget"
                    name="lighting_budget"
                    glyph="dollar"
                    :error="has_error('lighting_budget')"
                    :required="false"
                    :editable="editable"
                    width="1-1"
                    @input="save_field"
                    class="uk-width-1-1"
                />
            </div>
            <div class="uk-width-1-2">
                <div class="uk-form-controls-text uk-text-bold">Lighting Pricing</div>
                <div class="uk-flex uk-flex-middle">
                    <form-input
                        id="lighting_costs"
                        type="float"
                        v-model="record.lighting_costs"
                        name="lighting_costs"
                        glyph="dollar"
                        :error="has_error('lighting_costs')"
                        :required="false"
                        :editable="editable"
                        width="1-1"
                        @input="save_field"
                        class="uk-flex-item-1 uk-display-inline-block"
                    />
                    <form-radio-buttons
                        id="lighting_cost_units"
                        name="lighting_cost_units"
                        v-model="record.lighting_cost_units"
                        :options="cost_units"
                        label-field="label"
                        :error="has_error('lighting_cost_units')"
                        :editable="editable"
                        :required="false"
                        class=" uk-flex-item-none"
                        style="margin-top: 0;"
                        @input="save_field"
                    />
                </div>
            </div>
            <div class="uk-width-1-2">
                <div class="uk-form-controls-text uk-text-bold">Controls Budget</div>
                <form-input
                    id="controls_budget"
                    type="float"
                    v-model="record.controls_budget"
                    name="controls_budget"
                    glyph="dollar"
                    :error="has_error('controls_budget')"
                    :required="false"
                    :editable="editable"
                    width="1-1"
                    @input="save_field"
                    class="uk-width-1-1"
                />
            </div>
            <div class="uk-width-1-2">
                <div class="uk-form-controls-text uk-text-bold">Controls Pricing</div>
                <div class="uk-flex uk-flex-middle">
                    <form-input
                        id="controls_costs"
                        type="float"
                        v-model="record.controls_costs"
                        name="controls_costs"
                        glyph="dollar"
                        :error="has_error('controls_costs')"
                        :required="false"
                        :editable="editable"
                        width="1-1"
                        @input="save_field"
                        class="uk-flex-item-1 uk-display-inline-block"
                    />
                    <form-radio-buttons
                        id="controls_cost_units"
                        name="controls_cost_units"
                        v-model="record.controls_cost_units"
                        :options="cost_units"
                        label-field="label"
                        :error="has_error('controls_cost_units')"
                        :editable="editable"
                        :required="false"
                        class=" uk-flex-item-none"
                        style="margin-top: 0;"
                        @input="save_field"
                    />
                </div>
            </div>

            <div class="uk-width-1-1">
                <div class="uk-form-controls-text uk-text-bold">Notes</div>
                <form-text-area
                    id="budget_notes"
                    name="budget_notes"
                    v-model="record.budget_notes"
                    placeholder="Budget-related Notes..."
                    :editable="editable"
                    width="1-1"
                    :required="false"
                    @input="save_field"
                />
            </div>
        </div>
    </tab-section>
</template>

<script type="text/javascript">
import is_project_tab_section from "../mixins/IsProjectTabSection"
import string_utilities from "../../../mixins/StringUtilities"

import FormInput from "../../../ui/FormInput"
import FormTextArea from "../../../ui/FormTextArea"
import FormRadioButtons from "../../../ui/FormRadioButtons"

export default {
    mixins: [is_project_tab_section, string_utilities],
    components: {
        FormInput,
        FormTextArea,
        FormRadioButtons
    },
    computed: {
        cost_units () {
            return this.dictionary("cost_units")
        }
    }
}
</script>
